/**
 * All Asynchronous/AJAX state changes are made here. Each action defers to
 * a Mutation to actually 'commit' the required state change.
 */

import { groupService } from '@/server-util/group-service.js'
import { dashboardService } from '@/server-util/dashboard-service.js'
import { constants } from '@/utils/constants.js'

export default {
  /**
   * Fetches the Group identified by the passed in GroupID and sets it on the Store.
   *
   * @param {Object} context Essentially the Vuex Store
   */
  fetchAndSetSingleGroup ({ commit, state, dispatch, getters }, data) {
    let responseData = []
    let groupId = data

    groupService.getSingleGroup(state.access_token, groupId)
    .then(response => {
      /* eslint-disable */
      if (!_.isArray(response.data)) {
        responseData = _.castArray(response.data)
      } else {
        responseData = response.data
      }
      /* eslint-enable */

      commit('setGroups', responseData)
      commit('setSelectedGroup', state.groups[0])

      dispatch('fetchAndSetAllGroupData')
      .then(response => {})
      .catch(error => {
        commit('setRequestError', error)
      })
    })
    .catch(error => {
      alert(error)
    })
  },

  /**
   * Fetches all available Groups and sets them on the Store.
   *
   * @param {Object} context Essentially the Vuex Store
   */
  fetchAndSetGroups ({ commit, state, dispatch }) {
    groupService.listGroups(state.access_token)
    .then(response => {
      commit('setGroups', response.data)
      commit('setSelectedGroup', state.groups[0])

      dispatch('fetchAndSetAllGroupData')
      .then(response => {})
      .catch(error => {
        commit('setRequestError', error)
      })
    })
    .catch(error => {
      alert(error)
    })
  },

  fetchAndSetAllGroupData ({ state, commit, getters }) {
    let selectedGroup = state.selectedGroup
    let token = state.access_token
    let selectedTab = state.currDashboardTabSelection
    commit('setIsLoading', true)
    commit('resetGccData')
    return new Promise((resolve, reject) => {
      switch (selectedTab) {
        case 1:
          dashboardService.getAllGroupStats(token, selectedGroup.GroupId)
          .then(response => {
            /* eslint-disable */
            if (!getters.userIsInternal) {
              if (getters.userIsGroupAdmin) {
                // Remove Blacklisted Cohort Names
                _.forEach(response.data.GroupProgressDataList, course => {
                  _.remove(course.CohortProgressDataList, cohort => {
                    return _.includes(constants.BlacklistedNames.cohorts, _.toLower(_.trim(cohort.CohortName)))
                  })
                })

                // Remove IPL users
                _.forEach(response.data.GroupProgressDataList, course => {
                  _.forEach(course.CohortProgressDataList, cohort => {
                    _.remove(cohort.DashboardDataList, stat => {
                      return _.includes(stat.Email, '@personalleadership.com')
                    })
                  })
                })
              }
            }
            /* eslint-enable */

            commit('setAllGroupData', response.data)
            commit('setIsLoading', false)
            resolve(response)
          })
          .catch(error => {
            commit('setRequestError', error)
            commit('setIsLoading', false)
            reject(error)
          })
          break
        case 2:
          dashboardService.getMentoraMomentStats(token, selectedGroup.GroupId)
          .then(response => {
            /* eslint-disable */
            if (!getters.userIsInternal) {
              if (getters.userIsGroupAdmin) {
                // Remove Blacklisted Cohort Names
                _.forEach(response.data.GroupProgressDataList, course => {
                  _.remove(course.CohortProgressDataList, cohort => {
                    return _.includes(constants.BlacklistedNames.cohorts, _.toLower(_.trim(cohort.CohortName)))
                  })
                })

                // Remove IPL users
                _.forEach(response.data.GroupProgressDataList, course => {
                  _.forEach(course.CohortProgressDataList, cohort => {
                    _.remove(cohort.DashboardDataList, stat => {
                      return _.includes(stat.Email, '@personalleadership.com')
                    })
                  })
                })
              }
            }
            /* eslint-enable */
            commit('setAllGroupData', response.data)
            commit('setIsLoading', false)
            resolve(response)
          })
          .catch(error => {
            commit('setRequestError', error)
            commit('setIsLoading', false)
            reject(error)
          })
          break
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js